import type { HotkeyDefinition } from "./hotkey-registry";

// Mirrored by homeworks-php www/js/lib/copilot-global-search/global-search-shortcut.ts.
const APPLE_PLATFORM = /mac|ios|iphone|ipad|ipod/i;

/**
 * Command+key on Apple platforms and Ctrl+key elsewhere. Unlike "mod", this
 * leaves the other platform's modifier free, such as Ctrl+K text editing on macOS.
 * Falls back to Ctrl where `navigator` is unavailable, such as during SSR.
 */
export function platformShortcut(
  key: string,
): Pick<HotkeyDefinition, "keys" | "display"> {
  const platformNavigator:
    | (Navigator & { userAgentData?: { platform: string } })
    | undefined = typeof navigator === "undefined" ? undefined : navigator;
  const platform =
    platformNavigator?.userAgentData?.platform ||
    platformNavigator?.platform ||
    "";
  const isApple = APPLE_PLATFORM.test(platform);
  return isApple
    ? { keys: `meta+${key}`, display: `⌘${key.toUpperCase()}` }
    : { keys: `ctrl+${key}`, display: `Ctrl+${key.toUpperCase()}` };
}
